import { Controller } from "@hotwired/stimulus"

// The NPN purchase modal's open/leave behaviour — step 1 of NPN enforcement at
// lead purchase (#15158). The NPN entry itself (Verify → NIPR check → save) is
// change_npn_controller on the same element — the one-click Verify the Profile
// Update NPN modal shares (#15158 follow-up); this controller
// only decides how the modal opens and what dismissing it means.
//
// required (the buying page, OrderLeadsGate#open_npn_purchase_modal):
//   * opens itself on connect (static backdrop, no Escape — set by the partial);
//   * Cancel, the header X and any other hide LEAVE the page for leaveUrl —
//     there is no way to dismiss it into the order form underneath. The server
//     refuses every buying request anyway; this keeps the page honest.
//   * a successful save navigates away itself (change_npn → returnTo), which
//     is not a hide, so nothing here interferes with it.
// not required (the missing-info interstitial): the row's Fix opens it and
// Cancel / X simply close it — that page is not an order form.
export default class extends Controller {
  static values = { required: Boolean, leaveUrl: String }

  connect() {
    this.leaving = false
    if (this.requiredValue) queueMicrotask(() => this.open())
  }

  open() {
    const Modal = window.bootstrap?.Modal
    if (!Modal) return
    Modal.getOrCreateInstance(this.element).show()
  }

  // hide.bs.modal: a required modal never hides back onto the order form.
  guardHide(event) {
    if (!this.requiredValue) return
    event.preventDefault()
    this.leave()
  }

  leave() {
    if (this.leaving) return
    this.leaving = true
    window.location.assign(this.leaveUrlValue)
  }
}
